// 判断数据类型
export function dataType (data) {
  const type = Object.prototype.toString.call(data)
  let result = ''
  switch (type) {
    case '[object Object]':
      result = 'object'
      break
    case '[object Array]':
      result = 'array'
      break
    case '[object Function]':
      result = 'function'
      break
    case '[object Date]':
      result = 'date'
      break
    case '[object String]':
      result = 'string'
      break
    case '[object Number]':
      result = 'number'
      break
    case '[object Boolean]':
      result = 'boolean'
      break
    case '[object Null]':
      result = 'null'
      break
    case '[object Undefined]':
      result = 'undefined'
      break
  }
  return result
}

// 解析url参数并获取code
export function getUrlParam (name) { // name为要获取的参数名
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var rrr = decodeURIComponent(window.location.search)
  var r = rrr.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 金额千分位
export function amountFilter (val) {
  if (val === null || val === undefined) return
  val = (typeof val === 'number' ? val : parseFloat(val)).toFixed(2)
  const reg = /\d(?=(\d{3})+(?!\d))/g
  val = val.replace(reg, '$&,')
  return val
}

// 字典数据通过code取name
export function getNameByCode (code, list) {
  let name = ''
  list.forEach(item => {
    if (item.codeCd === code) {
      name = item.codeValue
    }
  })
  return name
}

// 字典数据通过code取name
export function getStatusById (id) {
  const list = [
    {
      value: 0,
      name: '待审批'
    }, {
      value: 1,
      name: '自动审批'
    }, {
      value: 2,
      name: '通过'
    }, {
      value: 3,
      name: '退回'
    }
  ]
  let name = ''
  list.forEach(item => {
    if (item.value === id) {
      name = item.name
    }
  })
  return name
}

// 日期对象格式化
export function formatDateNative (date, fmt = 'yyyy-MM-dd') {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

// 日期格式化
export function formatDate (date, fmt = 'yyyy-MM-dd') {
  if (!date) return date
  let str = ''
  if (dataType(date) === 'date' && !isNaN(date.getTime())) {
    str = formatDateNative(date, fmt)
  } else {
    date = date + ''
    const reg = /^(\d{4})(\D?)(\d{2})(\D?)(\d{2})(\D?)$/
    date.replace(reg, ($0, $1, $2, $3, $4, $5) => {
      const d = new Date($1, $3 - 1, $5)
      str = formatDateNative(d, fmt)
    })
  }
  return str
}



// WEBPACK FOOTER //
// ./src/common/utils.js